import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ClientFallBack = () => {
  const navigate = useNavigate();
    const { selectedClientData } = useSelector((state) => state?.main);

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', marginTop: '10%' }}>
      <Typography variant="h1" component="div" sx={{ color: "error" }} gutterBottom>
        404
      </Typography>
      <Typography variant="h4" gutterBottom>
        Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ color: "text.secondary" }} gutterBottom>
        The page you're looking for doesn't exist or has been moved.
      </Typography>
      <Box sx={{ mt: 4 }}>
        <Button variant="contained" color="primary" onClick={() => {
          if(selectedClientData?.ClientId){
            navigate(`/client/${selectedClientData?.ClientId}/home`)
          }else{
            navigate(`/home`)
          }
        }}>
          Go to Home
        </Button>
      </Box>
    </Container>
  );
};

export default ClientFallBack;
